<template>
  <div class="card">

    <div class="card">
      <div class="row">
        <div class="col-12 col-md-4 col-xl pb-1">
          <div class="card min-height card-hover-rise mb-0" style="background-color: #00cfe81f" @click="onClickDetailsPage('', 'total_active_job')">
            <div class="d-flex justify-content-between">
              <div class="text-left card-head">
                <h5 class="px-1 pt-1 font-bold">Total Active Job</h5>
              </div>
            </div>
            <hr style="margin:0">
            <div
                class="cursor-pointer card-body d-flex justify-content-between align-items-center p-1">
              <div class="truncate">
                <h4 class="mb-25 font-bold text-left">
                  {{ totalValue && totalValue.total_active_job }}
                </h4>
              </div>
              <span class="b-avatar badge-light-primary rounded-circle">
                <span class="b-avatar-custom">
                  <img id="img" :src="`/app-assets/images/icons/crm/all.png`" alt="">
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-xl pb-1" @click="onClickDetailsPage('', 'missed_deadline')">
          <div class="card min-height card-hover-rise mb-0" style="background-color: #28c76f1f">
            <div class="d-flex justify-content-between">
              <div class="text-left card-head">
                <h5 class="px-1 pt-1 font-bold">Missed Deadline</h5>
              </div>
            </div>
            <hr style="margin:0">
            <div
                class="cursor-pointer card-body d-flex justify-content-between align-items-center p-1">
              <div class="truncate">
                <h4 class="mb-25 font-bold text-left">
                  {{ totalValue && totalValue.missed_deadline }}
                </h4>
              </div>
              <span class="b-avatar badge-light-primary rounded-circle">
                <span class="b-avatar-custom">
                  <img id="img" :src="`/app-assets/images/icons/crm/active.png`" alt="">
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-xl pb-1">
          <div class="card min-height card-hover-rise mb-0" style="background-color: #fceaea" @click="onClickDetailsPage('', 'near_deadline')">
            <div class="d-flex justify-content-between">
              <div class="text-left card-head">
                <h5 class="px-1 pt-1 font-bold">Near Deadline</h5>
              </div>
            </div>
            <hr style="margin:0">
            <div
                class="cursor-pointer card-body d-flex justify-content-between align-items-center p-1">
              <div class="truncate">
                <h4 class="mb-25 font-bold text-left">
                  {{ totalValue && totalValue.near_deadline }}
                </h4>
              </div>
              <span class="b-avatar badge-light-primary rounded-circle">
                <span class="b-avatar-custom">
                  <img id="img" :src="`/app-assets/images/icons/crm/quotation.png`" alt="">
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-xl pb-1">
          <div class="card min-height card-hover-rise mb-0" style="background-color: #eeedfd" @click="onClickDetailsPage('', 'job_start_pending_count')">
            <div class="d-flex justify-content-between">
              <div class="text-left card-head">
                <h5 class="px-1 pt-1 font-bold">Job Start - Pending</h5>
              </div>
            </div>
            <hr style="margin:0">
            <div
                class="cursor-pointer card-body d-flex justify-content-between align-items-center p-1">
              <div class="truncate">
                <h4 class="mb-25 font-bold text-left">
                  {{ totalValue && totalValue.job_start_pending_count }}
                </h4>
              </div>
              <span class="b-avatar badge-light-primary rounded-circle">
                <span class="b-avatar-custom">
                  <img id="img" :src="`/app-assets/images/icons/crm/order.png`" alt="">
                </span>
              </span>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-4 col-xl pb-1" @click="onClickDetailsPage('', 'job_completed_this_month')">
          <div class="card min-height card-hover-rise mb-0" style="background-color: #28c76f1f">
            <div class="d-flex justify-content-between">
              <div class="text-left card-head">
                <h5 class="px-1 pt-1 font-bold">Jobs Completed This Month</h5>
              </div>
            </div>
            <hr style="margin:0">
            <div
                class="cursor-pointer card-body d-flex justify-content-between align-items-center p-1">
              <div class="truncate">
                <h4 class="mb-25 font-bold text-left">
                  {{ totalValue && totalValue.job_completed_this_month }}
                </h4>
              </div>
              <span class="b-avatar badge-light-primary rounded-circle">
                <span class="b-avatar-custom">
                  <img id="img" :src="`/app-assets/images/icons/crm/all.png`" alt="">
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr>

    <div class="px-1">
      <div class="row">
        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
          <label class="form-label">Business Unit</label>
          <v-select
              placeholder="Select Business"
              v-model="businessId"
              :options="business"
              label="name"
              :reduce="name => name.id"
          />
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
          <label class="form-label">Client Name</label>
          <AsyncSelect
              placeholder="Client Name"
              v-model="clientId"
              :api-service="fetchContactProfiles"
              :reduce="text => text.id"
              :additional-query="{ roles: 'customer,lead' }"
          />
        </div>

        <div class="col-12 col-sm-6 col-md-4 col-lg-3 mr-top-1">
          <label class="form-label">Type</label>
          <v-select
              placeholder="Select Type"
              v-model="applicationType"
              :options="surveyApplicationType"
              label="name"
              :reduce="name => name.value"
          />
        </div>

        <div class="col-sm-2 col-md-1 d-flex align-items-end mt-2 action-btn-setter">
          <button
              style="min-width: 64px;"
              @click="onClickGo"
              class="btn btn-primary btn-block waves-effect waves-float waves-light"
          >GO
          </button>
        </div>
      </div>
    </div>

    <div class="col-12 mb-4">
      <div class="card" style="min-height: 200px">
        <div v-if="tableItems.length > 0" class="stages-grid">
          <div
              v-for="(item, i) in tableItems"
              :key="i"
              class="stage-card"
          >
            <div class="stage-header">
              <span class="stage-label">{{ item.name }}</span>
            </div>

            <div class="stage-count cursor-pointer" @click="onClickDetailsPage(item)">
              {{ item.total_projects }}
            </div>

            <div class="leads-list">
              <div v-for="(pipeline, index) in item.projects.slice(0,5)" :key="pipeline.id">
                <div class="lead-item">
                  {{ pipeline.project_name }}
                </div>
              </div>
            </div>
            <div class="stage-header text-right cursor-pointer" @click="onClickDetailsPage(item)">
              <span class="stage-label">See More..</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Loader v-if="loading" />
  </div>
</template>

<script setup>
import { inject, onMounted, ref } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import Loader from '@/components/atom/LoaderComponent'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import handleProjects from "@/services/modules/procurement/project";
import handleContact from "@/services/modules/contact";
import handlePurchase from '@/services/modules/purchase';
import handleCBusinesses from '@/services/modules/businesses'
import handleChartAccount from '@/services/modules/chartAccount'

const store = useStore();
const route = useRoute();
const router = useRouter();
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const loading = ref(false)
const tableItems = ref([]);
const params = ref({
  offset: 10,
});
const projectId = ref(null);
const clientId = ref(null);
const businessId = ref(null);
const productIds = ref([]);
let business = ref([])
let permittedAccess = ref({})
let totalValue = ref({})
const applicationType = ref(null);
const surveyApplicationType = ref([]);

const { fetchHome } = handleChartAccount()
const {fetchBusinessList} = handleCBusinesses()
const {
  fetchJobTrackerOverview
} = handleProjects();
const { fetchContactProfiles } = handleContact();
const { fetchProductList } = handlePurchase();

const onClickDetailsPage = (item = null, status = null) => {
  let query = { ...route.query }
  delete query.start;
  delete query.end;
  query.type = 'overview';
  if (item.id){
    query.job_stage_id = item.id;
  }
  if (status){
    query.status_type = status
  }
  let routeName = 'job-tracker-details';
  if (status == 'job_start_pending_count') {
    routeName = 'pending-project-initiate'
  }

  const routeData = router.resolve({
    name: routeName,
    params: route.params,
    query: query
  });

  window.open(routeData.href, '_blank');
}
const onClickGo = async () => {
  const query = getQuery();
  loading.value = true
  tableItems.value = []
  await fetchJobTrackerOverview(query).then(res => {
    if (!res.status){
      return
    }

    tableItems.value = res.data.data;
    totalValue.value = res.data.total;
  }).catch(err => {
    console.log(err)
  }).finally(() => {
    loading.value = false
  })
}

const getQuery = () => {
  let query = `?company_id=${route.params.companyId}`;
  if(clientId.value) query += '&client_id=' + clientId.value
  if(businessId.value) query += '&business_id=' + businessId.value
  if(applicationType.value) query += '&type=' + applicationType.value
  return query;
}

onMounted(() => {
  const query = `?company_id=${route.params.companyId}`;
  const businessRes = fetchBusinessList(query)

  Promise.all([
    onClickGo(),
    businessRes.then(res=> {
      if(res.data) business.value = res.data
    }),
    fetchHome().then(res => {
      if (!res.data) {
        return;
      }
      if (res.data && res.data.survey_application_type){
        surveyApplicationType.value = res.data.survey_application_type;
      }
    })
  ])
})
</script>

<style scoped>
.mr-top-1 {
  margin-top: 1% !important;
}
.min-height {
  min-height: 120px;
}
#img {
  width: 40px;
}
.card-hover-rise {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.card-hover-rise:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}
.font-bold {
  font-weight: bold;
}
.truncate h4{
  font-size: 30px;
}
.card-head {
  h2 {
    font-weight: bold;
  }
}
.stages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.5rem;
  padding: 1.5rem;
}

.stage-card {
  background: white;
  border-radius: 0.25rem;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 1px solid #dee2e6;
  display: flex;
  flex-direction: column;
}

.stage-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  border-color: #c3cad4;
}

/* Stage Header */
.stage-header {
  background: linear-gradient(135deg, #f0f2f5 0%, #e8ebf0 100%);
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #dee2e6;
}

.stage-label {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  letter-spacing: 0.3px;
}

/* Stage Count */
.stage-count {
  font-size: 3.5rem;
  font-weight: 800;
  color: #7367f0;
  text-align: center;
  padding: 1.5rem 1rem;
  letter-spacing: -1px;
  line-height: 1;
  border-bottom: 1px solid #dee2e6;
}

/* Leads List */
.leads-list {
  flex-grow: 1;
  padding: 1rem;
  background: white;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-height: 90px;
}

.lead-item {
  font-size: 0.85rem;
  color: #666;
  padding: 0.5rem 0;
  line-height: 1.4;
  font-weight: 400;
}

.lead-item.placeholder {
  color: #999;
  font-style: italic;
  text-align: center;
  margin: auto 0;
}

/* Button Override for better spacing */
.stage-card .btn {
  border-radius: 0;
  margin: 0;
  padding: 0.75rem 1.5rem;
  font-size: 0.9rem;
  font-weight: 600;
  letter-spacing: 0.4px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.stage-card .btn:hover {
  transform: translateY(-1px);
}

.stage-card .btn:active {
  transform: translateY(0);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .stages-grid {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 1.25rem;
    padding: 1.25rem;
  }

  .stage-count {
    font-size: 3rem;
  }
}

@media (max-width: 768px) {
  .stages-grid {
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 1rem;
    padding: 1rem;
  }

  .stage-count {
    font-size: 2.5rem;
    padding: 1.25rem 0.75rem;
  }

  .stage-header {
    padding: 0.65rem 0.85rem;
  }

  .stage-label {
    font-size: 0.85rem;
  }

  .leads-list {
    padding: 0.85rem;
    min-height: 80px;
  }

  .lead-item {
    font-size: 0.8rem;
  }

  .stage-card .btn {
    padding: 0.75rem 1.25rem;
    font-size: 0.85rem;
  }
}

@media (max-width: 576px) {
  .stages-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 0.75rem;
    padding: 0.75rem;
  }

  .stage-count {
    font-size: 2rem;
    padding: 1rem 0.5rem;
  }

  .stage-header {
    padding: 0.6rem 0.75rem;
  }

  .stage-label {
    font-size: 0.8rem;
  }

  .leads-list {
    padding: 0.75rem;
    min-height: 70px;
    gap: 0.3rem;
  }

  .lead-item {
    font-size: 0.75rem;
    padding: 0.3rem 0;
  }

  .stage-card .btn {
    padding: 0.65rem 1rem;
    font-size: 0.8rem;
  }
}
</style>